export const procedures = [
      {
            id: 1,
            name: { EN: 'Botox', ES: 'Bótox', PT: 'Botox' },
            content: {
                  EN: `Botox is a quick, minimally invasive treatment that reduces wrinkles by relaxing facial muscles. It’s also used medically for conditions like migraines and excessive sweating.

Procedure: Small injections are administered in 15-30 minutes with no downtime.

Post-Treatment Care:
First 24 Hours: Avoid pressure on treated areas and intense activities.
After 7-14 Days: Full results are visible and last 3-6 months.
Botox offers a safe, effective way to achieve a youthful look or treat medical issues with minimal recovery.`,
                  ES: `El Bótox es un tratamiento rápido y mínimamente invasivo que reduce las arrugas al relajar los músculos faciales. También se utiliza médicamente para afecciones como migrañas y sudoración excesiva.

Procedimiento: Las pequeñas inyecciones se administran en 15-30 minutos sin tiempo de inactividad.

Cuidados Post-Tratamiento:
Primeras 24 Horas: Evitar la presión en las áreas tratadas y las actividades intensas.
Después de 7-14 Días: Los resultados completos son visibles y duran de 3 a 6 meses.
El Bótox ofrece una forma segura y efectiva de lograr un aspecto juvenil o tratar problemas médicos con una recuperación mínima.`,
                  PT: `O Botox é um tratamento rápido e minimamente invasivo que reduz as rugas relaxando os músculos faciais. Também é usado clinicamente para condições como enxaquecas e suor excessivo.

Procedimento: Pequenas injeções são administradas em 15-30 minutos, sem tempo de inatividade.

Cuidados Pós-Tratamento:
Primeiras 24 Horas: Evitar a pressão nas áreas tratadas e atividades intensas.
Após 7-14 Dias: Os resultados completos são visíveis e duram de 3 a 6 meses.
O Botox oferece uma maneira segura e eficaz de alcançar uma aparência jovem ou tratar problemas médicos com recuperação mínima.`
            },
            image: './proceduresfolder/Botox.webp'
      },
      {
            id: 2,
            name: { EN: 'Laser', ES: 'Láser', PT: 'Laser' },
            content: {
                  EN: `Laser treatments are advanced, non-invasive procedures used to improve skin texture, tone, and appearance. They effectively address concerns like wrinkles, scars, pigmentation, and unwanted hair.

Common Applications:
Skin resurfacing for wrinkles and scars.
Treating hyperpigmentation and sun damage.
Hair removal.

Procedure: Sessions typically last 15-60 minutes. Minimal downtime is required.

Post-Treatment Care:
Avoid sun exposure and apply sunscreen.
Mild redness or swelling resolves within a few days.`,
                  ES: `Los tratamientos con láser son procedimientos avanzados y no invasivos utilizados para mejorar la textura, el tono y la apariencia de la piel. Abordan eficazmente problemas como arrugas, cicatrices, pigmentación y vello no deseado.

Aplicaciones Comunes:
Rejuvenecimiento de la piel para arrugas y cicatrices.
Tratamiento de la hiperpigmentación y el daño solar.
Depilación.

Procedimiento: Las sesiones suelen durar entre 15 y 60 minutos con un tiempo de inactividad mínimo.

Cuidados Post-Tratamiento:
Evitar la exposición al sol y aplicar protector solar.
El enrojecimiento leve se resuelve en pocos días.`,
                  PT: `Os tratamentos a laser são procedimentos avançados não invasivos usados para melhorar a textura, o tom e a aparência da pele. Aborda eficazmente preocupações como rugas, cicatrizes, pigmentação e pelos indesejados.

Aplicações Comuns:
Rejuvenescimento da pele para rugas e cicatrizes.
Tratamento da hiperpigmentação e danos solares.
Depilação.

Procedimento: As sessões normalmente duram de 15 a 60 minutos com tempo de inatividade mínimo.

Cuidados Pós-Tratamento:
Evitar a exposição solar e aplicar protetor solar.
Vermelhidão leve se resolve em poucos dias.`
            },
            image: './proceduresfolder/Laser.webp'
      },
      {
            id: 3,
            name: { EN: 'Collagen Biostimulators', ES: 'Biostimuladores de Colágeno', PT: 'Bioestimuladores de Colágeno' },
            content: {
                  EN: `Collagen biostimulators are injectable treatments that restore volume, improve skin elasticity, and stimulate natural collagen production for long-lasting rejuvenation.

How They Work:
Sculptra: Gradually restores volume by stimulating collagen over time.
Radiesse: Provides immediate volume and stimulates collagen.

Procedure:
Performed in 30-60 minutes with little to no downtime. Results last up to 18-24 months.

Post-Treatment Care:
Massage treated areas as advised.
Avoid intense physical activity for 24 hours.`,
                  ES: `Los bioestimuladores de colágeno son tratamientos inyectables que restauran el volumen, mejoran la elasticidad de la piel y estimulan la producción natural de colágeno.

Cómo Funcionan:
Sculptra: Restaura gradualmente el volumen estimulando el colágeno.
Radiesse: Proporciona volumen inmediato y estimula el colágeno.

Procedimiento:
Realizado en 30-60 minutos con poco o ningún tiempo de inactividad. Los resultados duran hasta 18-24 meses.

Cuidados Post-Tratamiento:
Masajear las áreas tratadas según lo aconsejado.
Evitar la actividad física intensa durante 24 horas.`,
                  PT: `Os bioestimuladores de colágeno são tratamentos injetáveis que restauram o volume, melhoram a elasticidade da pele e estimulam a produção natural de colágeno.

Como Funcionam:
Sculptra: Restaura o volume gradualmente, estimulando o colágeno.
Radiesse: Proporciona volume imediato e estimula o colágeno.

Procedimento:
Realizado em 30-60 minutos com pouco ou nenhum tempo de inatividade. Os resultados duram até 18-24 meses.

Cuidados Pós-Tratamento:
Massageie as áreas tratadas conforme recomendado.
Evite atividades físicas intensas por 24 horas.`
            },
            image: './proceduresfolder/Biostimulators.webp'
      },
      {
            id: 4,
            name: { EN: 'Hand Rejuvenation', ES: 'Rejuvenecimiento de Manos', PT: 'Rejuvenescimento das Mãos' },
            content: {
                  EN: `Hand rejuvenation treatments restore volume, improve skin texture, and reduce visible signs of aging such as wrinkles, sunspots, and prominent veins.

Common Treatments:
Dermal Fillers: Restore lost volume.
Laser Therapy: Reduces pigmentation.
Chemical Peels: Lighten sunspots.

Procedure: Minimally invasive, lasting 30-60 minutes.

Post-Treatment Care: Protect hands with sunscreen.`,
                  ES: `Los tratamientos de rejuvenecimiento de manos restauran el volumen, mejoran la textura de la piel y reducen los signos visibles de envejecimiento como arrugas y manchas solares.

Tratamientos Comunes:
Rellenos Dérmicos: Restauran el volumen.
Terapia con Láser: Reduce la pigmentación.
Peelings Químicos: Aclaran las manchas solares.

Procedimiento: Mínimamente invasivo, de 30 a 60 minutos.

Cuidados Post-Tratamiento: Proteger las manos del sol.`,
                  PT: `Os tratamentos de rejuvenescimento das mãos restauram o volume, melhoram a textura da pele e reduzem os sinais visíveis de envelhecimento, como rugas e manchas solares.

Tratamentos Comuns:
Preenchedores Dérmicos: Restauram o volume.
Terapia a Laser: Reduz a pigmentação.
Peelings Químicos: Clareiam as manchas solares.

Procedimento: Minimamente invasivo, de 30 a 60 minutos.

Cuidados Pós-Tratamento: Proteger as mãos do sol.`
            },
            image: './proceduresfolder/HandRejuvenation.webp'
      },
      {
            id: 5,
            name: { EN: 'Ultraformer', ES: 'Ultraformer', PT: 'Ultraformer' },
            content: {
                  EN: `Ultraformer is a non-invasive treatment that uses high-intensity focused ultrasound (HIFU) to tighten skin, reduce wrinkles, and lift facial and body contours.

Common Applications:
Facial lifting and tightening.
Body contouring and skin firming.

Procedure: A session lasts 30-60 minutes with no downtime.
Results: Visible improvements appear gradually over 2-3 months.`,
                  ES: `Ultraformer es un tratamiento no invasivo que utiliza ultrasonido focalizado de alta intensidad (HIFU) para tensar la piel, reducir arrugas y levantar el rostro.

Aplicaciones Comunes:
Lifting facial.
Contorno corporal y firmeza de la piel.

Procedimiento: Una sesión dura unos 30-60 minutos sin inactividad.
Resultados: Mejoras visibles aparecen gradualmente en 2 a 3 meses.`,
                  PT: `O Ultraformer é um tratamento não invasivo que utiliza ultrassom focado de alta intensidade (HIFU) para firmar a pele, reduzir rugas e levantar o rosto.

Aplicações Comuns:
Lifting facial e firmeza da pele.
Contorno corporal.

Procedimento: Uma sessão dura 30-60 minutos sem inatividade.
Resultados: Melhorias visíveis aparecem gradualmente em 2-3 meses.`
            },
            image: './proceduresfolder/Ultraformer.webp'
      },
      {
            id: 6,
            name: { EN: 'Hyaluronic Acid', ES: 'Ácido Hialurónico', PT: 'Ácido Hialurônico' },
            content: {
                  EN: `Hyaluronic acid fillers are injectable treatments used to restore volume, smooth wrinkles, and enhance facial contours.

Common Uses:
Lip enhancement.
Filling nasolabial folds.
Contouring cheeks and jawline.

Procedure: Quick and minimally invasive, lasting 15-30 minutes.

Post-Treatment Care:
Avoid intense physical activity for 24 hours.`,
                  ES: `Los rellenos de ácido hialurónico son tratamientos inyectables utilizados para restaurar el volumen, suavizar arrugas y mejorar contornos faciales.

Usos Comunes:
Aumento de labios.
Relleno de surcos nasogenianos.
Contorno de pómulos y mandíbula.

Procedimiento: Rápido y mínimamente invasivo (15-30 minutos).

Cuidados Post-Tratamiento: Evitar actividad física intensa por 24 horas.`,
                  PT: `Os preenchedores de ácido hialurônico são tratamentos injetáveis usados para restaurar o volume, suavizar rugas e melhorar os contornos faciais.

Usos Comuns:
Aprimoramento dos lábios.
Preenchimento de sulcos nasolabiais.
Contorno de bochechas e mandíbula.

Procedimento: Rápido e minimamente invasivo (15-30 minutos).

Cuidados Pós-Tratamento: Evite atividades físicas intensas por 24 horas.`
            },
            image: './proceduresfolder/HyaluronicAcid.webp'
      },
      {
            id: 7,
            name: { EN: 'Botox Hyperhidrosis', ES: 'Bótox para Hiperhidrosis', PT: 'Botox para Hiperidrose' },
            content: {
                  EN: `Botox is highly effective in treating hyperhidrosis (excessive sweating) in the underarms, hands, or feet.

How it works: It temporarily blocks the chemical signals from the nerves that stimulate the sweat glands.

Procedure: Quick and minimally invasive, lasting 15-30 minutes with immediate results.

Post-Treatment Care: Avoid intense physical activity for 24 hours.`,
                  ES: `El Bótox es altamente efectivo para tratar la hiperhidrosis (sudoración excesiva) en las axilas, palmas o plantas.

Cómo funciona: Bloquea temporalmente las señales químicas de los nervios que estimulan las glándulas sudoríparas.

Procedimiento: Rápido, de 15-30 minutos, sin inactividad.

Cuidados Post-Tratamiento: Evitar actividad intensa por 24 horas.`,
                  PT: `O Botox é altamente eficaz no tratamento da hiperidrose (suor excessivo) nas axilas, mãos e pés.

Como funciona: Bloqueia temporariamente os sinais químicos dos nervos que estimulam as glândulas sudoríparas.

Procedimento: Rápido, de 15 a 30 minutos, sem inatividade.

Cuidados Pós-Tratamento: Evite atividades intensas por 24 horas.`
            },
            image: './proceduresfolder/Hyperhidrosis.webp'
      },
      {
            id: 8,
            name: { EN: 'Lip Fillers', ES: 'Aumento de Labios', PT: 'Preenchimento Labial' },
            content: {
                  EN: `Lip fillers are a minimally invasive treatment designed to enhance lip volume, shape, and definition using hyaluronic acid.

Procedure: Takes 15-30 minutes with minimal discomfort. Results are immediate.

Post-Treatment Care:
Avoid hot beverages and lip pressure for 24 hours.
Use cold compresses to reduce swelling.`,
                  ES: `El aumento de labios es un tratamiento para mejorar el volumen, forma y definición de los labios utilizando ácido hialurónico.

Procedimiento: Tarda entre 15 y 30 minutos con un mínimo de molestias. Los resultados son inmediatos.

Cuidados Post-Tratamiento:
Evitar bebidas calientes y presión en los labios por 24 horas.
Usar compresas frías para reducir la inflamación.`,
                  PT: `O preenchimento labial é um tratamento para aumentar o volume, a forma e a definição dos lábios usando ácido hialurônico.

Procedimento: Demora de 15 a 30 minutos com desconforto mínimo. Os resultados são imediatos.

Cuidados Pós-Tratamento:
Evite bebidas quentes e pressão nos lábios por 24 horas.
Use compressas frias para reduzir o inchaço.`
            },
            image: './proceduresfolder/LipFillers.webp'
      },
      {
            id: 9,
            name: { EN: 'Facial Harmonization', ES: 'Armonización Facial', PT: 'Harmonização Facial' },
            content: {
                  EN: `Facial harmonization is a customized approach to enhance facial balance and proportions using non-surgical procedures like fillers and Botox.

Common Areas Treated:
Cheeks: Add volume.
Nose: Non-surgical rhinoplasty.
Chin and Jawline: Define and balance lower face.

Procedure: Performed in 30-60 minutes with minimal discomfort.`,
                  ES: `La armonización facial es un enfoque personalizado para mejorar el equilibrio facial utilizando procedimientos no quirúrgicos como rellenos y bótox.

Áreas Tratadas Comúnmente:
Mejillas: Añadir volumen o lifting sutil.
Nariz: Rinomodelación sin cirugía.
Mentón y Mandíbula: Definir la parte inferior del rostro.

Procedimiento: Realizado en 30-60 minutos.`,
                  PT: `A harmonização facial é uma abordagem personalizada para melhorar o equilíbrio facial usando procedimentos não cirúrgicos, como preenchedores e Botox.

Áreas Comuns Tratadas:
Bochechas: Adicionar volume.
Nariz: Rinomodelação não cirúrgica.
Queixo e Mandíbula: Definir o rosto inferior.

Procedimento: Realizado em 30-60 minutos.`
            },
            image: './proceduresfolder/FacialHarmonization.webp'
      },
      {
            id: 10,
            name: { EN: 'Skinbooster', ES: 'Skinboosters', PT: 'Skinboosters' },
            content: {
                  EN: `Skinboosters are injectable treatments designed to deeply hydrate and improve the texture and elasticity of the skin. They target fine lines and dryness.

Benefits:
Hydrates from within.
Reduces fine lines and wrinkles.

Procedure: Takes 20-40 minutes with minimal discomfort.

Results: Visible improvement after 1-2 weeks.`,
                  ES: `Los Skinboosters son tratamientos inyectables diseñados para hidratar profundamente y mejorar la textura y elasticidad de la piel, atacando líneas finas y sequedad.

Beneficios:
Hidratación desde el interior.
Reducción de líneas de expresión.

Procedimiento: Dura 20-40 minutos con pocas molestias.

Resultados: Mejoría visible tras 1-2 semanas.`,
                  PT: `Os Skinboosters são tratamentos injetáveis concebidos para hidratar profundamente e melhorar a textura e elasticidade da pele, combatendo rugas finas e secura.

Benefícios:
Hidratação de dentro para fora.
Redução de linhas de expressão.

Procedimento: Dura 20-40 minutos com desconforto mínimo.

Resultados: Melhoria visível após 1-2 semanas.`
            },
            image: './proceduresfolder/Skinbooster.webp'
      },
      {
            id: 11,
            name: { EN: 'Microneedling', ES: 'Microneedling (Dermapen)', PT: 'Microagulhamento' },
            content: {
                  EN: `Microneedling is a minimally invasive treatment that boosts collagen, improving skin texture, scars, wrinkles, and pores.

Procedure: 30-60 minutes; numbing cream may be applied. Can be combined with serums or PRP.

Post-Care:
Redness for 1-2 days. Avoid sun and use sunscreen.

Results: Gradual improvement over weeks.`,
                  ES: `El Microneedling es un tratamiento que estimula el colágeno, mejorando la textura de la piel, cicatrices, arrugas y poros.

Procedimiento: 30-60 minutos. Se puede usar crema anestésica y combinar con sueros o PRP (plasma rico en plaquetas).

Cuidados:
Enrojecimiento por 1-2 días. Evitar el sol.

Resultados: Mejora gradual en semanas.`,
                  PT: `O Microagulhamento é um tratamento que estimula o colágeno, melhorando a textura da pele, cicatrizes, rugas e poros dilatados.

Procedimento: 30-60 minutos. Creme anestésico pode ser usado e combinado com soros ou PRP.

Cuidados Pós-Tratamento:
Vermelhidão por 1-2 dias. Evite sol e use protetor.

Resultados: Melhoria gradual ao longo de semanas.`
            },
            image: './proceduresfolder/Microneedling.webp'
      },
      {
            id: 12,
            name: { EN: 'Chemical Peel', ES: 'Peeling Químico', PT: 'Peeling Químico' },
            content: {
                  EN: `A chemical peel is a skin-resurfacing treatment that uses a chemical solution to exfoliate and remove damaged skin layers to improve texture.

Benefits:
Reduces acne scars and pigmentation.
Improves skin brightness.

Procedure: Quick, lasting 15-30 minutes.

Results: Smoother, clearer skin visible after healing.`,
                  ES: `Un Peeling Químico es un tratamiento de rejuvenecimiento de la superficie de la piel que utiliza una solución química para exfoliar y eliminar capas dañadas de la piel.

Beneficios:
Reduce cicatrices de acné y pigmentación.
Mejora el brillo y textura.

Procedimiento: Rápido, de 15 a 30 minutos.

Resultados: Piel más suave y clara después de pelarse.`,
                  PT: `O Peeling Químico é um tratamento de renovação da pele que utiliza uma solução química para esfoliar camadas danificadas da pele.

Benefícios:
Reduz cicatrizes de acne e manchas.
Melhora o brilho.

Procedimento: Rápido, durando de 15 a 30 minutos.

Resultados: Pele mais lisa e clara visível após a cicatrização.`
            },
            image: './proceduresfolder/ChemicalPeel.webp'
      },
      {
            id: 13,
            name: { EN: 'Therapeutic Botox (Migraine/Bruxism)', ES: 'Bótox Terapéutico (Migraña/Bruxismo)', PT: 'Botox Terapêutico (Enxaqueca/Bruxismo)' },
            content: {
                  EN: `Botulinum toxin is an effective treatment for medical conditions like migraines and bruxism (teeth grinding). It relaxes targeted muscles.

Benefits:
Migraines: Reduces frequency and severity.
Bruxism: Relieves jaw pain and protects teeth from damage.

Procedure: Quick, lasting 15-30 minutes.
Results appear within 1-2 weeks.`,
                  ES: `La toxina botulínica es un tratamiento eficaz para condiciones médicas como las migrañas y el bruxismo (rechinar los dientes), relajando los músculos.

Beneficios:
Migrañas: Reduce frecuencia y severidad.
Bruxismo: Alivia el dolor de mandíbula y protege los dientes.

Procedimiento: 15-30 minutos.
Resultados en 1-2 semanas.`,
                  PT: `A toxina botulínica é um tratamento eficaz para doenças pré-existentes como enxaquecas e bruxismo, relaxando músculos específicos.

Benefícios:
Enxaquecas: Reduz a frequência e a gravidade.
Bruxismo: Alivia a dor no maxilar e protege os dentes.

Procedimento: Rápido, de 15 a 30 minutos.
Os resultados aparecem dentro de 1 a 2 semanas.`
            },
            image: './proceduresfolder/BotulinumToxin.webp'
      }
];
